export default __webpack_public_path__ + "static/media/outdoor.f16b721a.jpg";